import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { JobInfo } from 'src/app/recruiting/locums-margin-calculator/models/job-info.model';
import { combine } from 'src/app/shared/utilities/route';

@Injectable({ providedIn: 'root' })
export class JobService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getJobInfo(jobId: number): Observable<JobInfo> {
        const url = combine(this.coreApiPath, `locums/job/${jobId}`);
        return this.http.get<JobInfo>(url);
    }
}
